module.exports = __webpack_public_path__ + "static/media/vendor_notification.8e21bdbf.png";